var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.5488H1.92C1.54 15.5488 1.22 15.2588 1.17 14.8788L-2.92156e-06 4.37875C-0.0300029 4.09875 0.0999971 3.82875 0.329997 3.66875C0.569997 3.50875 0.869997 3.50875 1.11 3.64875L5.67 6.25875L8.33 0.958752C8.46 0.708752 8.72 0.548752 9 0.548752C9.28 0.548752 9.54 0.708752 9.67 0.958752L12.32 6.24875L16.88 3.63875C17.13 3.49875 17.44 3.50875 17.67 3.66875C17.91 3.82875 18.03 4.10875 17.99 4.39875L16.49 14.8988C16.44 15.2688 16.12 15.5388 15.75 15.5388V15.5488ZM2.59 14.0488H15.1L16.29 5.70875L12.37 7.94875C12.19 8.04875 11.98 8.07875 11.78 8.01875C11.58 7.95875 11.42 7.81875 11.33 7.63875L9 2.97875L6.67 7.63875C6.58 7.81875 6.41 7.95875 6.22 8.01875C6.02 8.07875 5.81 8.05875 5.63 7.94875L1.66 5.67875L2.59 14.0488Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.1087C8.81 12.1087 8.62 12.0387 8.47 11.8887L7.41 10.8287C7.27 10.6887 7.19 10.4987 7.19 10.2987C7.19 10.0987 7.27 9.90875 7.41 9.76875L8.47 8.70875C8.76 8.41875 9.24 8.41875 9.53 8.70875L10.59 9.76875C10.73 9.90875 10.81 10.0987 10.81 10.2987C10.81 10.4987 10.73 10.6887 10.59 10.8287L9.53 11.8887C9.38 12.0387 9.19 12.1087 9 12.1087Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.5488H3.75C3.34 18.5488 3 18.2088 3 17.7988C3 17.3888 3.34 17.0488 3.75 17.0488H14.25C14.66 17.0488 15 17.3888 15 17.7988C15 18.2088 14.66 18.5488 14.25 18.5488Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.abf2043c5b8b76e06f125551d697418e.svg";
export { ForwardRef as ReactComponent };